import React, { useEffect, useState } from 'react'
import { NumericFormat } from 'react-number-format';
import axios from 'axios';
import { jsonrepair } from 'jsonrepair';

const parseJsonSeguro = (valor, fallback = []) => {
	try {
		return valor ? JSON.parse(jsonrepair(valor)) : fallback
	} catch (error) {
		return fallback
	}
}

const normalizarProductoPos = (item) => {
	const imagen = parseJsonSeguro(item.url_imagen, [])

	return {
		...item,
		categoria_producto: parseJsonSeguro(item.categoria_producto, []),
		atributos: parseJsonSeguro(item.atributos, []),
		imagePrev: imagen[0]?.nombre_imagen || '',
		inventarioCantidad: parseInt(item.inventarioCantidad),
		visualizacion: parseJsonSeguro(item.visualizacion, []),
		url_imagen: imagen
	}
}

const ProductosPos = ({ funcion, baseUrl, onClick, filtro, textoBuscador, onCategoriasChange, refreshKey, urlProductosPos }) => {
	const [productosActuales, setProductosActuales] = useState([])
	const [paginaActual, setPaginaActual] = useState(1)
	const [hasMore, setHasMore] = useState(false)
	const [cargando, setCargando] = useState(false)

	const traerProductos = async ({ page = 1, append = false }) => {
		setCargando(true)

		try {
			const { data } = await axios.get(urlProductosPos, {
				params: {
					page,
					limit: 30,
					categoria: textoBuscador ? '' : filtro,
					search: textoBuscador
				}
			})

			const productosNormalizados = (data.items || []).map(normalizarProductoPos)
			setProductosActuales(prev => append ? [...prev, ...productosNormalizados] : productosNormalizados)
			setHasMore(Boolean(data.hasMore))
			setPaginaActual(page)

			if (data.categorias && onCategoriasChange) {
				onCategoriasChange(data.categorias)
			}
		} catch (error) {
			console.log(error)
			if (!append) {
				setProductosActuales([])
			}
			setHasMore(false)
		} finally {
			setCargando(false)
		}
	}

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			traerProductos({ page: 1, append: false })
		}, 250)

		return () => clearTimeout(timeoutId)
	}, [filtro, textoBuscador, refreshKey, urlProductosPos])

	const handleCargarMas = () => {
		if (cargando || !hasMore) return
		traerProductos({ page: paginaActual + 1, append: true })
	}

	return (
		<>
			<div className=" animate__animated animate__rubberBand animate__slow contProductos d-none d-sm-none d-md-flex" id="scrollableDiv">
				{funcion === 'cargando' ?
					<div className="loader">Cargando...</div>
					: null}
				{funcion === 'ver' ?
					<ProductosListado
						baseUrl={baseUrl}
						cargando={cargando}
						hasMore={hasMore}
						items={productosActuales}
						onClick={onClick}
						onLoadMore={handleCargarMas}
					/>
					: null}
			</div >

			<div className=" animate__animated animate__rubberBand animate__slow contProductos d-flex d-sm-flex d-md-none" >
				{funcion === 'cargando' ?
					<div className="loader">Cargando...</div>
					: null}
				{funcion === 'ver' ?
					<ProductosListado
						baseUrl={baseUrl}
						cargando={cargando}
						hasMore={hasMore}
						items={productosActuales}
						onClick={onClick}
						onLoadMore={handleCargarMas}
					/>
					: null}
			</div >
		</>
	);
}

const ProductosListado = ({ items, baseUrl, onClick, hasMore, onLoadMore, cargando }) => (
	<>
		<ProductosItems itemsScroll={items} baseUrl={baseUrl} onClick={onClick} />
		{!cargando && items.length === 0 ? <div className="col-12 text-center py-4">No hay productos para mostrar.</div> : null}
		{hasMore ?
			<div className="col-12 text-center py-3">
				<button className="btn boton_estandar" onClick={onLoadMore} type="button">
					Cargar más
				</button>
			</div>
			: null}
		{cargando ? <div className="col-12 text-center py-3">Cargando productos...</div> : null}
	</>
)

const ProductosItems = ({ itemsScroll, baseUrl, onClick }) => itemsScroll.map((producto, index) => {
	if (producto.activo === 'true') {

		if (producto.inventario == "true" && producto.inventarioCantidad <= 0) {

			return (
				<React.Fragment key={index}>
					<div className="col-lg-3 col-md-4 col-6 CatProductos Agotado">
						<button
							name={producto.nombre_producto}
							className="btnProducto btn btn-block">
							Agotado
							<img
								src={baseUrl + 'productos/' + producto.imagePrev}
								className="img-responsive imageProducto"
								loading="lazy"
								decoding="async"
							/>
						</button>
						<h5 name={producto.nombre_producto}>{`${producto.nombre_producto}`}</h5>

						{producto.precio_rebajado > 0 ?
							<p>
								<span className="tachado">
									<NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
								</span><span> </span><NumericFormat value={producto.precio_rebajado} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
							: <p><NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
						}

					</div>

				</React.Fragment>
			)

		} else {
			return (
				<React.Fragment key={index}>
					<div className="col-lg-3 col-md-4 col-6 CatProductos">

						<button
							name={producto.nombre_producto}
							onClick={() => onClick(producto, index)}
							className="btnProducto btn btn-block">
							<img
								src={baseUrl + 'productos/' + producto.imagePrev}
								className="img-responsive imageProducto"
								loading="lazy"
								decoding="async"
							/>
						</button>
						<h5 name={producto.nombre_producto}>{`${producto.nombre_producto}`} {producto.inventario == "true" && producto.inventarioCantidad ? `x${producto.inventarioCantidad}` : ''}  </h5>
						{producto.precio_rebajado > 0 ?
							<p>
								<span className="tachado">
									<NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
								</span><span> </span><NumericFormat value={producto.precio_rebajado} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
							: <p><NumericFormat value={producto.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
						}

					</div>
				</React.Fragment>
			)

		}
	}
})


export default ProductosPos
